import { initDropdown, updateDropdownParams } from "../components/initDropdown.js";
import initModals from "../components/initModals.js";
import initSliders from "../components/initSliders.js";

document.addEventListener("DOMContentLoaded", () => {


    initDropdown();
    initModals();

    const { initModalProductSlider } = initSliders();
    initModalProductSlider();

    // Нужно вызвать при любом клике на меню, который меняет выбор
    document.addEventListener('click', async e => {
        const item = e.target.closest('[data-dropdown-menu-trigger]');

        if (!item) return;

        try {
            const response = await axios.post(updateDropdownParams(),{
                currentUrl: window.location.href
            });
            if (response.status === 200) {

                const targetListContainer = document.querySelector('#product__grid');

                //clear existing items
                targetListContainer.innerHTML = '';
                //append new items
                targetListContainer.innerHTML = response.data.products_view;
                initModals();
                initModalProductSlider();

            } else {
                console.error('Failed to load items');
            }
        } catch (error) {
            console.error('Error loading items:');
        }
    });

    document.addEventListener('click', async (e) => {
        const btn = e.target.closest('[data-pagination-show-more]');
        if (!btn) return;

        e.preventDefault();

        const target = btn.dataset.paginationShowMore;

        if (target !== '.products__grid') return;

        const currentUrl = btn.dataset.paginationUrl;

        const url = new URL(currentUrl, window.location.origin);
        const queryOnly = url.search;
        const pathname = window.location.pathname;

        const apiUrl = `/api/add-more-products${pathname}${queryOnly}`;

        const urlObj = new URL(window.location.href);
        urlObj.search = queryOnly;
        history.replaceState(null, '', urlObj.toString());

        try {
            const response = await axios.post(apiUrl, {
                currentUrl: currentUrl,
            });

            if (response.status === 200) {

                const targetContainer = document.querySelector(target);
                const currentPagination = document.querySelector('.pagination__block');

                const productsToAdd = response.data.products_to_add;
                const newPagination = response.data.paginator;

                targetContainer.insertAdjacentHTML('beforeend', productsToAdd);

                if (currentPagination && newPagination) {
                    currentPagination.innerHTML = newPagination;
                }

                initModals();
                initModalProductSlider();
            }

        } catch (error) {
            console.error('Failed to load add more items');
        }
    });

});

